import {ValueObject} from '@s-ui/domain'

export default class UrlValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Object} deps.url
   */

  isValid({invalidUrlErrorFactory}) {
    if (!this._url) throw invalidUrlErrorFactory('URL is required')
  }

  getUrl = () => this._url

  setUrl = url => (this._url = url)
}
